//GET_ALL_EMPLOYEE_DESIGNATION
export const GET_ALL_EMPLOYEE_DESIGNATION_REQUEST =
  "GET_ALL_EMPLOYEE_DESIGNATION_REQUEST";
export const GET_ALL_EMPLOYEE_DESIGNATION_SUCCESS =
  "GET_ALL_EMPLOYEE_DESIGNATION_SUCCESS";
export const GET_ALL_EMPLOYEE_DESIGNATION_FAIL =
  "GET_ALL_EMPLOYEE_DESIGNATION_FAIL";

//UPDATE_EMPLOYEE_DESIGNATION
export const UPDATE_EMPLOYEE_DESIGNATION_REQUEST =
  "UPDATE_EMPLOYEE_DESIGNATION_REQUEST";
export const UPDATE_EMPLOYEE_DESIGNATION_SUCCESS =
  "UPDATE_EMPLOYEE_DESIGNATION_SUCCESS";
export const UPDATE_EMPLOYEE_DESIGNATION_FAIL =
  "UPDATE_EMPLOYEE_DESIGNATION_FAIL";

// //ARCHIVE_EMPLOYEE_DESIGNATION
// export const ARCHIVE_EMPLOYEE_DESIGNATION_REQUEST = "ARCHIVE_EMPLOYEE_DESIGNATION_REQUEST";
// export const ARCHIVE_EMPLOYEE_DESIGNATION_SUCCESS = "ARCHIVE_EMPLOYEE_DESIGNATION_SUCCESS";
// export const ARCHIVE_EMPLOYEE_DESIGNATION_FAIL = "ARCHIVE_EMPLOYEE_DESIGNATION_FAIL";

//CREATE_EMPLOYEE_DESIGNATION
export const CREATE_EMPLOYEE_DESIGNATION_REQUEST =
  "CREATE_EMPLOYEE_DESIGNATION_REQUEST";
export const CREATE_EMPLOYEE_DESIGNATION_SUCCESS =
  "CREATE_EMPLOYEE_DESIGNATION_SUCCESS";
export const CREATE_EMPLOYEE_DESIGNATION_FAIL =
  "CREATE_EMPLOYEE_DESIGNATION_FAIL";

//DELETE_EMPLOYEE_DESIGNATION
export const DELETE_EMPLOYEE_DESIGNATION_REQUEST =
  "DELETE_EMPLOYEE_DESIGNATION_REQUEST";
export const DELETE_EMPLOYEE_DESIGNATION_SUCCESS =
  "DELETE_EMPLOYEE_DESIGNATION_SUCCESS";
export const DELETE_EMPLOYEE_DESIGNATION_FAIL =
  "DELETE_EMPLOYEE_DESIGNATION_FAIL";

//  BULK_ASSIGN_EMPLOYEE_DESIGNATION
export const BULK_ASSIGN_EMPLOYEE_DESIGNATION_REQUEST =
  "BULK_ASSIGN_EMPLOYEE_DESIGNATION_REQUEST";
export const BULK_ASSIGN_EMPLOYEE_DESIGNATION_SUCCESS =
  "BULK_ASSIGN_EMPLOYEE_DESIGNATION_SUCCESS";
export const BULK_ASSIGN_EMPLOYEE_DESIGNATION_FAIL =
  "BULK_ASSIGN_EMPLOYEE_DESIGNATION_FAIL";

// //DELETE_EMPLOYEE_DESIGNATION
// export const DELETE_EMPLOYEE_DESIGNATION_REQUEST = "DELETE_EMPLOYEE_DESIGNATION_REQUEST";
// export const DELETE_EMPLOYEE_DESIGNATION_SUCCESS = "DELETE_EMPLOYEE_DESIGNATION_SUCCESS";
// export const DELETE_EMPLOYEE_DESIGNATION_FAIL = "DELETE_EMPLOYEE_DESIGNATION_FAIL";
